<footer role="doc-footnote">
    <div class="bg-blue-footer px-2 md:px-4 xl:px-0">
      <div class="gov-container width-container mx-auto relative section-main-footer
       flex justify-content-between align-items-center">
        <p-card styleClass="lg:py-5 lg:px-7 w-full px-4 pt-1 pb-4"
                class="w-full shadow-border-light absolute border-round-xl">
          <div class="grid">
            <div class="col-12 lg:col-6">
              <h1 class="text-3xl font-principal title-blue sm:w-26rem ml-0 mb-0 animated-text">
                Portal de Trámites de la Gobernación del Magdalena
              </h1>
              <p class="p-0 mb-2 mt-0 app-text-gray text-lg animated-text">NIT: 800103920-6</p>
            </div>
            <div class="col-12 lg:col-6  justify-content-start flex lg:justify-content-end ">
              <a role="link">
                <picture>
                  <source media="(width < 800px)" srcset="assets/img/icons-principal/logo-header-main-responsive.png">
                  <source media="(width >= 800px)" srcset="assets/img/icons-principal/logo-header-main.png">
                  <img class=" logo-main" src="assets/img/icons-principal/logo-header-main.png"
                       draggable="false" alt="Portal de Tramites Gobernacion del Magdalena"/>
                </picture>
              </a>
            </div>
            <div class="col-12 pb-0 font-principal" role="contentinfo">
              <h2 class="title-blue ml-0 text-lg bold animated-text"> Sede principal</h2>
              <p class="app-text-gray my-2 text-lg animated-text">Dirección: <span
                class="text-blue-general animated-text">Carrera 1 No. 16-15 Palacio Tayrona</span></p>
              <p class="app-text-gray mb-2 animated-text  mt-0 text-lg">Codigo Portal:
                <a class="text-blue-general  animated-text no-underline">47004</a>
              </p>
              <p class="app-text-gray mb-2  mt-0 text-lg animated-text">Horario de Atención: </p>
              <p class="app-text-gray mb-2  mt-0 text-lg animated-text">Lunes a Viernes de 8:00am a 12:00m y de 2:00pm a 6:00pm</p>
              <p class="app-text-gray mb-2  mt-0 text-lg animated-text">Teléfono:
                <a class="text-blue-general no-underline animated-text" href="tel:+576054210239">(+57) (605)4210239</a>
                Fax: <a class="text-blue-general no-underline animated-text">(+57) (605)4210239</a>
              </p>
              <p class="app-text-gray mb-2  mt-0 text-lg animated-text">Correo anticorrupción:
                <a class="text-blue-general no-underline animated-text" href="mailto:soytransparente@magdalena.gov.co">soytransparente&#64;magdalena.gov.co</a>
              </p>
              <p class="app-text-gray mb-2  mt-0 text-lg animated-text">Correo Institucional:
                <a class="text-blue-general no-underline" href="mailto:contactenos@magdalena.gov.co">contactenos&#64;magdalena.gov.co</a>
              </p>
              <p class="app-text-gray mb-2  mt-0 text-lg animated-text">Notificaciones judiciales:
                <a class="text-blue-general no-underline" href="mailto:notificacionjudicial@magdalena.gov.co">notificacionjudicial&#64;magdalena.gov.co</a>
              </p>
              <p class="app-text-gray mb-2  mt-0 animated-text text-lg">
                Última actualización el 3 octubre de 2024
              </p>
              <a class="text-blue-general text-lg animated-text" role="link" href="#">
                DIRECTORIO INSTITUCIONAL
              </a>

            </div>

            <div class="col-12 mt-4 pb-0">
              <div class="flex justify-content-between flex-column md:flex-row">
                <div class="inline-flex gap-5 align-items-center">
                  <a role="link" href="https://www.facebook.com/gobernaciondelmagdalena/">
                    <img ngSrc="assets/img/svg/gov-facebook.svg" alt="Facebook Gobernacion del Magdalena"
                         width="15.56" height="27.8" draggable="false" priority="auto"/>
                  </a>
                  <a role="link" href="https://x.com/magdalenagober">
                    <img ngSrc="assets/img/svg/gov-X.svg" alt="X de Gobernación del Magdalena"
                         width="24.06" height="22.56" draggable="false" priority="auto"/>
                  </a>
                  <a role="link" href="https://www.youtube.com/channel/UCJGp9DktS-ICVYzCrON5RrQ">
                    <img ngSrc="assets/img/svg/gov-youTube.svg" alt="YouTube Gobernacion del Magdalena"
                         width="31.26" height="22.22" draggable="false" priority="auto"/>
                  </a>
                  <a role="link">
                    <img ngSrc="assets/img/svg/gov-linkedIn.svg" alt="LinkedIn Gobernacion del Magdalena"
                         width="27.74" height="27.47" draggable="false" priority="auto"/>
                  </a>
                  <a role="link" href="https://www.instagram.com/magdalenagober/">
                    <img ngSrc="assets/img/svg/gov-instagram.svg" alt="LinkedIn Gobernacion del Magdalena"
                         width="26.93" height="26.97" draggable="false" priority="auto"/>
                  </a>
                </div>
                <div class="flex align-items-center ">
                  <ul class="flex gap-4 m-0 list-none justify-content-end flex-column md:flex-row
                 align-items-start sm:align-items-baseline pl-0 pt-5 sm:pt-0">
                    <li>
                      <a href="#" class="text-blue-general">Políticas</a>
                    </li>
                    <li>
                      <a href="#" class="text-blue-general">Mapa Del Sitio</a>
                    </li>
                    <li>
                      <a href="#" class="text-blue-general">Términos Y Condiciones</a>
                    </li>
                    <li>
                      <a href="#" class="text-blue-general">Accesibilidad</a>
                    </li>
                  </ul>
                </div>
              </div>
            </div>

          </div>

        </p-card>
      </div>
    </div>
    <div class="bg-blue-base" style="height:60px">
      <div class=" width-container mx-auto h-full px-4 flex align-items-center ">
        <a role="link" href="https://colombia.co" rel="noopener" target="_blank"
           aria-label="Logo Colombia. Te llevará al inicio de marca país">
          <picture>
            <source media="(width < 800px)" srcset="assets/img/icons-principal/co-x1.png">
            <source media="(width >= 800px)" srcset="assets/img/icons-principal/co-x2.png">
            <img ngSrc="assets/img/icons-principal/co-x2.png" width="42.74" height="41.88"
                 alt="Logo Colombia.co" priority="auto" draggable="false"/>
          </picture>

        </a>
        <hr class="mx-1" style="height:40px;">
        <a target="_blank" role="link" class="mt-1" href="https://www.gov.co" rel="noopener"
           aria-label="Logo Gobierno de Colombia. Te llevará al inicio">
          <img ngSrc="assets/img/svg/logo-gov.svg" alt="logo gov.co" height="26"
               priority="auto" draggable="false" width="120.44"/>
        </a>
      </div>
    </div>

</footer>
